import { message } from 'antd';

export const ReportType = {
  COOPERADOS: 'cooperados',
  GESTAO: 'gestao',
};

export const reportTypes = [
  { value: 'all', label: 'Todos' },
  { value: ReportType.COOPERADOS, label: 'Cooperados' },
  { value: ReportType.GESTAO, label: 'Gestão e Apontamentos' },
];

export const categories = [
  {
    id: 'cooperados',
    name: 'Cooperados',
    reports: [
      {
        id: 1,
        type: ReportType.COOPERADOS,
        icon: 'user',
        title: 'Relatório de Afastados',
        description: 'Relatório de cooperados afastados da cooperativa',
        path: '/reports/inactive-cooperators',
      },
    ],
  },
];
